import { IContactModuleProps, IModalProps } from '../../interfaces/interfaces';

export default {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  openPersonalisation: (openModal: (modal: IModalProps) => void, isLocal?: boolean) => {
    openModal({
      type: 'personalization',
      key: 'personalization-modal',
      message: '',
      isLocal,
      onAbort: () => {
        //---
      },
      onConfirm: () => {
        //---
      },
    });
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  openContactFormModal: (
    openModal: (modal: IModalProps) => void,
    data: IContactModuleProps,
    onConfirm: (confirmData?: any) => void,
    onAbort: () => void,
  ): void => {
    openModal({
      type: 'contactform',
      key: 'contactform-modal',
      message: '',
      info: '',
      onAbort,
      onConfirm,
      data,
    });
  },

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  openOnboarding: (openModal: (modal: IModalProps) => void) => {
    openModal({
      type: 'onboarding',
      key: 'onboarding',
      message: '',
      onAbort: () => {
        //---
      },
      onConfirm: () => {
        //---
      },
    });
  },

  openAppStore: (openModal: (modal: IModalProps) => void) => {
    openModal({
      type: 'appstore',
      key: 'appstore',
      message: '',
      onAbort: () => {
        //---
      },
      onConfirm: () => {
        //---
      },
    });
  },

  openFavouriteListModalEdit: (openModal: (modal: IModalProps) => void): void => {
    openModal({
      type: 'favouriteEdit',
      key: 'favouriteEdit',
      message: '',
      onAbort: () => {
        //---
      },
      onConfirm: () => {
        //---
      },
    });
  },
};
